module.exports = __webpack_public_path__ + "img/user.9a165d4f.svg";